

import ReactWebChat, { createDirectLine, type createStore } from 'botframework-webchat';
import React, { memo, useEffect, useMemo } from 'react';
import { appConfig } from '../../../utils/app.config';
import './WebChat.css';
import { useSelector } from 'react-redux';

type Props = Readonly<{
  className?: string | undefined;
  onFetchToken?: (() => void) | undefined;
  store: ReturnType<typeof createStore>;
  styleOptions: any;
  styleSet: any;
  token: string;
  sendMessage: boolean;
  setSendMessage?: ((value: boolean) => void);
  message: string;
}>;

function WebChat({
  className = "react-web-chat",
  onFetchToken = () => { },
  store = {} as ReturnType<typeof createStore>, // default empty store
  styleOptions = {},
  styleSet = {},
  token = "",
  sendMessage = false,
  setSendMessage = () => { },
  message = ''
}: Props) {
  console.log("----styleOptions:", styleOptions);

  // const userProfile = useSelector((store: any) => store.login.loginDetails);

  let domain = `${appConfig.baseUrl}/gwt/channels/v1.0`
  const directLine = useMemo(() => createDirectLine(
    {
      token: token,
      // domain: domain,
      webSocket: true,  //was true before (message msg sent failed issue)
      //  pollingInterval: 5000 //comment// 
    } as any), [token]);

  useEffect(() => {
    onFetchToken?.();
  }, [onFetchToken]);

  if (sendMessage && message) {
    const send = async () => {
      await directLine.postActivity({
        "attachments": [],
        "channelData": {
          "attachmentSizes": [],
          "clientActivityID": generateClientActivityID()
        },
        "text": message,
        "textFormat": "plain",
        "type": "message",
        "channelId": "webchat",
        "from": {
          "id": '',
          "name": "",
          "role": "user"
        },
        "locale": "en-US"
      }).toPromise();
    }
    send();
    setSendMessage(false)
  }

  return token ? (
    <ReactWebChat
      className={`${className || ''} web-chat`}
      directLine={directLine}
      store={store}
      styleOptions={styleOptions}
    //styleSet={styleSet}
    />
  ) : (
    <div className={`${className || ''} connect-spinner`}>
      <div className="content">
        <div className="icon">
          <span className="ms-Icon ms-Icon--Robot" ></span>
        </div>
        <p>{'Please wait while we are connecting.'}</p>
      </div>
    </div>
  );
}

function generateClientActivityID(): string {
  const length = 10;
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

export default memo(WebChat);
